/**
 * Formats an image URL, ensuring it is absolute and correctly prefixed.
 * If the URL is relative (starts with /), it prefixes it with NEXT_PUBLIC_API_URL.
 */
export const getImageUrl = (url: string | null | undefined): string => {
    if (!url) return '';

    // If it's already an absolute URL (starts with http, https, or data:)
    if (/^(https?:\/\/|data:)/i.test(url)) {
        return url;
    }

    // If it's a relative URL starting with /uploads (from API)
    if (url.startsWith('/uploads')) {
        const apiUrl = process.env.NEXT_PUBLIC_API_URL || '';
        // Standardize clean joining
        const base = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        return `${base}${url}`;
    }

    // If it starts with / but not /uploads, it's likely a local public asset
    if (url.startsWith('/')) {
        return url;
    }

    // Fallback for relative paths without leading slash (assume API if not absolute)
    const apiUrl = process.env.NEXT_PUBLIC_API_URL || '';
    const base = apiUrl.endsWith('/') ? apiUrl : `${apiUrl}/`;
    return `${base}${url}`;
};
